<template>
  <div class="second_cloudBooth">

    <div :style="
    'padding:' + options.data.pageCss.page_css_padding + 
    ';margin:' + options.data.pageCss.page_css_margin + 
    ';border-radius:' + options.data.pageCss.page_css_radius + 
    'px;background-color:' + options.data.pageCss.textBgc+';'+options.data.pageCss.myCss" class="dataBox">
      <div v-if="!showDetail" class="list">

        <div class="noData" v-if='!options.data.menuArr||!options.data.menuArr[0]'>暂无内容</div>

        <div v-for="(item,index) in options.data.menuArr" :key="item.id" @click="goYzt(index+1)" class="item">
          <div class="item_img pointer">
            <span v-if="!item.icon_path">{{item.title}}</span>
            <p v-if="item.icon_path"><img width="100%" :src="item.icon_path" alt=""></p>
          </div>
        </div>

      </div>
      <div v-if="showDetail" class="list">
        <div class="dataBoxDeta">
          <div class="logo">
            <img width="100%" :src="options.data.menuArr[showDetail-1].icon_path" alt="">
          </div>

          <div class="videoBox">
            <video controls="controls" preload="auto" webkit-playsinline="" playsinline="" x-webkit-airplay="allow"
              x5-playsinline="true" :poster="options.data.menuArr[showDetail-1].cover_path" class="video"
              :src="options.data.menuArr[showDetail-1].live_link"></video>
          </div>

          <div class="video_message">
            <viewer :images='[options.data.menuArr[showDetail-1].content]'>
              <p class="bigImg" v-html="options.data.menuArr[showDetail-1].content"></p>
            </viewer>
          </div>

        </div>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import { getVideoList } from '@/api/meetApi.js';
import { mapGetters, mapActions } from "vuex";
export default {
  name: "second_cloudBooth",
  props: ["index", "activeIndex"],
  data() {
    return {
      list: [],
      showDetail: ''
    };
  },
  computed: {
    ...mapGetters(["okForm"]),
    ...mapGetters(["workPlace"]),
    options() {
      this.$forceUpdate()
      return this.okForm[this.index]
        ? this.okForm[this.index].options
        : { data: this.workPlace.second_cloudBooth.data };
    },
  },

  watch: {
    okForm: {
      handler(newVal, oldVal) {
        this.$forceUpdate()
      },
      deep: true,
    },
    '$route.query': {
      handler(newParams, oldParams) {
        if (newParams.show_id) {
          this.showDetail = newParams.show_id
        } else {
          this.showDetail = ''
        }
        console.log(this.showDetail)
      },
      immediate: true,
      deep: true,
    }
  },

  created() {
    // this.getList()
  },
  methods: {
    async getList() {
      let data = await getVideoList({ meeting_id: this.$route.query.meeting_id })
      this.list = data.payload.data
      console.log(data)
    },
    goYzt(id) {
    // 因为详情页无法获取到配置的图标信息等内容，所以云展台组件不设置详情页，直接隐藏列表显示详情内容。
    // 会导致返回异常，所以再当前页面做一次原地刷新，使返回键生效
      this.$router.push('/?view_id=' + this.$route.query.view_id + '&show_id=' + id)
    }

  }
};
</script>

<style lang="less" scoped>
:deep(.bigImg img) {
  width: 100% !important;
  height: unset;
}
.noData {
  text-align: center;
  color: #888888;
}
.second_cloudBooth {
  display: flex;
  flex-direction: column;
}

.dataBox {
  flex: 1;
  position: relative;
  margin-bottom: 0px;
  .list {
    .item:last-child {
      margin-bottom: 0;
    }
    .item_s:last-child {
      border-bottom: 0px solid #000;
    }
  }
}

.icon {
  width: 100%;
  text-align: center;
  font-size: 0px;
  margin: 10px 0;
  img {
    width: 45%;
  }
}

.item {
  background-color: #fff;
  margin-bottom: 12px;
}

.item_img {
  width: 100%;
  min-height: 50px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #eecc9d;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 768px) {
  .second_cloudBooth {
    display: flex;
    border-radius: 0 0 8px 8px;
    // border-bottom: 1px solid #000;
    // min-height: 100vh;
  }
}

// @media (min-width: 750px) {
//   .icon {
//     top: -19px;
//     img {
//       width: 338px;
//     }
//   }
// }

.video,
.videoBox {
  background-color: black;
  width: 100%;
  height: 56.7vw;
  max-width: 768px;
  max-height: 436px;
  margin-bottom: 12px;
  border-radius: 8px;
}
.dataBoxDeta {
  border: 1px solid #eecc9d;
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  position: relative;
  top: -2.3vw;
  overflow: hidden;
}
.logo {
  margin-bottom: 6px;
}
.video_message {
  overflow: hidden;
  border-radius: 8px;
}
.end_img {
  text-align: center;
  padding: calc(24px - 2.3vw) 0 24px 0;
}
@media screen and (min-width: 768px) {
  .dataBox {
    top: -18px;
  }
  .end_img {
    padding: 0 0 24px 0;
  }
}
</style>